import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@unite-us/ui';
var Stepper = function Stepper(_ref) {
  var steps = _ref.steps;
  return /*#__PURE__*/React.createElement("nav", {
    "aria-label": "Progress"
  }, /*#__PURE__*/React.createElement("ol", {
    className: "pl-0 border border-solid border-med-pale-blue rounded-md md:flex md:divide-y-0"
  }, _mapInstanceProperty(steps).call(steps, function (step, stepIdx) {
    return /*#__PURE__*/React.createElement("li", {
      key: step.name,
      className: "relative inline-block md:flex-1 md:flex"
    }, step.status === 'complete' ? /*#__PURE__*/React.createElement("span", {
      onClick: step.onClick,
      className: "group flex items-center w-full".concat(step.onClick ? ' cursor-pointer' : '')
    }, /*#__PURE__*/React.createElement("span", {
      className: "px-6 py-4 flex items-center text-sm font-bold"
    }, /*#__PURE__*/React.createElement("span", {
      className: "flex-shrink-0 w-10 h-10 flex items-center justify-center bg-purple rounded-full"
    }, /*#__PURE__*/React.createElement(Icon, {
      className: "w-4 h-4 text-white fill-current",
      "aria-hidden": "true",
      icon: "IconCheck"
    })), /*#__PURE__*/React.createElement("span", {
      className: "ml-4 text-sm font-bold text-purple"
    }, step.name))) : step.status === 'current' ? /*#__PURE__*/React.createElement("span", {
      onClick: step.onClick,
      className: "px-6 py-4 flex items-center text-sm font-bold".concat(step.onClick ? ' cursor-pointer' : ''),
      "aria-current": "step"
    }, /*#__PURE__*/React.createElement("span", {
      // eslint-disable-next-line max-len
      className: "flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-solid border-purple rounded-full"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-purple"
    }, step.id)), /*#__PURE__*/React.createElement("span", {
      className: "ml-4 text-sm font-bold text-purple"
    }, step.name)) : /*#__PURE__*/React.createElement("span", {
      onClick: step.onClick,
      className: "group flex items-center".concat(step.onClick ? ' cursor-pointer' : '')
    }, /*#__PURE__*/React.createElement("span", {
      className: "px-6 py-4 flex items-center text-sm font-bold"
    }, /*#__PURE__*/React.createElement("span", {
      // eslint-disable-next-line max-len
      className: "flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-solid border-grey rounded-full"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-grey"
    }, step.id)), /*#__PURE__*/React.createElement("span", {
      className: "ml-4 text-sm font-bold text-grey"
    }, step.name))), stepIdx !== steps.length - 1 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "sm:hidden md:block absolute top-0 right-0 h-full w-5",
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("svg", {
      className: "h-full w-full text-med-pale-blue",
      viewBox: "0 0 22 80",
      fill: "none",
      preserveAspectRatio: "none"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M0 -2L20 40L0 82",
      vectorEffect: "non-scaling-stroke",
      stroke: "currentcolor",
      strokeLinejoin: "round"
    })))) : null);
  })));
};
Stepper.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    status: PropTypes.oneOf(['complete', 'current', 'upcoming']).isRequired
  })).isRequired
};
export default Stepper;
//# sourceMappingURL=Stepper.js.map